import { html, LitElement, nothing, TemplateResult } from "lit";
import { customElement, state } from "lit/decorators.js";

@customElement("content-modal")
export class ContentModalElement extends LitElement {
    @state()
    private _isOpen: boolean = false;

    @state()
    private _title: string = "";

    @state()
    private _content: TemplateResult<1> | null = null;


    public override connectedCallback() {
        super.connectedCallback();
        window.addEventListener("show-modal-requested", this.handleShowRequested.bind(this));
        window.addEventListener("hide-modal-requested", this.closeModal.bind(this));
    }

    private handleShowRequested(event: Event) {
        const customEvent = event as CustomEvent<ModalRequestEventDetail>;
        this._isOpen = true;
        this._title = customEvent.detail.title;
        this._content = customEvent.detail.content;
    }

    private closeModal() {
        this._isOpen = false;
        this._title = "";
        this._content = null;
    }


    protected override render() {
        if (!this._isOpen) {
            return nothing;
        }

        return html`
            <div class="fixed inset-0 top-20 z-40 flex items-center justify-center bg-black/25 backdrop-blur-sm" @click="${this.closeModal}">
                <div class="bg-white rounded-lg p-6 w-dvw lg:w-3xl max-w-3xl shadow-lg relative">
                    <h2 class="text-xl font-semibold mb-4">${this._title}</h2>
                    <div class="overflow-auto">${this._content}</div>
                    <button @click="${this.closeModal}" class="cursor-pointer text-gray-700 absolute top-4 right-4">
                        <svg class="mx-auto size-8">
                            <use href="#close-icon" />
                        </svg>
                    </button>
                </div>
            </div>
        `;
    }

    protected override createRenderRoot() {
        return this;
    }
}

export interface ModalRequestEventDetail  {
    title: string;
    content: TemplateResult<1>
}